export default __webpack_public_path__ + "static/5-d8d2dab77af8c4083349b3d15bd0939a.svg";